import React from 'react'
import { formatFullName, formatDateMDY, formatSSN, formatFullAddress, getTagValue, getAttrValue, getEleArray, getTagAttrValue } from 'helpers/Helpers';

export default function Variations({variations}) {
	//console.log("vars: ", variations, variations.length, typeof variations,);

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Variations</div>
			</div>
			<div className='w-full flex flex-col border-2'>
				{
					variations.map((cf, i) => {
						return (<Var key={i} cf={cf} />);
					})
				}
			</div>
		</div>
	)
}

function Var({cf}) {
	// get header data
	//console.log("cf: ",typeof cf, cf.length, cf);
	var bor = cf._BORROWER;
	var fn = getAttrValue(bor, "_UnparsedName");
	var ssn = formatSSN(bor);

	var rep = getAttrValue(cf, "CreditFileID");
	var date = formatDateMDY(getAttrValue(cf, "_InfileDate"));
	var since = formatDateMDY(getAttrValue(cf, "_SinceDate"));

	var alias = getEleArray(bor, "_ALIAS");
	var addrs = getEleArray(bor, "_RESIDENCE");
	var empl = getEleArray(bor, "EMPLOYER");
	

	return (
		<div className='w-full flex flex-col pb-2 value'>
			<div className='flex flex-row'>
				<div className='w-[100px] pl-2 title'>Repository:</div>
				<div className='w-[200px]'>{rep}</div>
				<div className='w-[70px] title'>Date:</div>
				<div className='w-[200px]'>{date}</div>
				<div className='w-[70px] title'>Since:</div>
				<div className='w-[200px]'>{since}</div>
			</div>
			<div className='flex flex-row'>
				<div className='w-[100px] pl-2 title'>Name:</div>
				<div className='w-[470px]'>{fn}</div>
				<div className='w-[70px] title'>SSN:</div>
				<div className='w-[200px]'>{ssn}</div>
			</div>
			<div className='flex flex-col'>
				{ alias && 
					alias.map((a, i) => {
						return (<Alias key={i} alias={a} />)
					})
				}
				{ addrs && 
					addrs.map((a, i) => {
						return (<Address key={i} addr={a} />)
					})
				}
				{ empl && 
					empl.map((e, i) => {
						return (<Employer key={i} empl={e} />)
					})
				}
			</div>
		</div>
	)
}

function Alias({alias}) {
	//console.log("alias: ", alias);
	var name = formatFullName(alias);

	return (
		<div className='flex flex-row value pl-8'>
			<div className='w-[150px] title'>Also Known As:</div>
			<div className='w-[500]'>{name}</div>
		</div>
	)
}

function Address({addr}) {

	var adr = formatFullAddress(addr);
	var date = formatDateMDY(getTagValue(addr, "ReportedDate"));
	var type = getAttrValue(addr, "BorrowerResidencyType");
	return (
		<div className='flex flex-row value pl-8'>
			<div className='w-[150px] title'>{type} Address:</div>
			<div className=''>{adr}</div>
			<div className='w-[100px] text-end'>{date}</div>
		</div>
	)
}

function Employer({empl}) {

	var name = getAttrValue(empl, "_Name");
	var date = formatDateMDY(getAttrValue(empl, "EmploymentReportedDate"));
	var cur = getAttrValue(empl, "EmploymentCurrentIndicator");
	var type = (cur === 'Y') ? 'Current' : 'Former';

	return (
		<div className='flex flex-row value pl-8'>
			<div className='w-[150px] title'>{type} Employer:</div>
			<div className='w-[500]'>{name}</div>
			<div className='w-[100px] text-end'>{date}</div>
		</div>
	)
}

